<template lang="pug">
.card.mb-0
  .card-body
    .row
      .col
        .d-flex.flex-wrap
          b-form-group.mb-2.mr-4(:label="$t('ui.greeting')")
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="include_greeting" :disable="loading")
              span.custom-switch-indicator
          b-form-group.mb-2.mr-4(:label="$t('ui.cta')")
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="category" :disable="loading")
              span.custom-switch-indicator
          b-form-group.mb-2.flex-grow-1(v-if="category == true" :label="$t('ui.href')")
            DebounceInput(
              size="sm"
              ref="remark"
              required
              type="text"
              :dirty="$v.remark.$dirty"
              :error="$v.remark.$error"
              v-model.trim.lazy="$v.remark.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.remark" :name="$t('ui.href')")
        b-form-group(:label="$t('ui.title')").mb-0
          DebounceInput(
            size="sm"
            ref="title"
            required
            type="text"
            :dirty="$v.title.$dirty"
            :error="$v.title.$error"
            v-model.trim.lazy="$v.title.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.title" :name="$t('ui.title')")
        b-form-group(:label="$t('ui.body')" :disable="loading").mb-3
          b-form-textarea(
            :dirty="$v.body.$dirty"
            :error="$v.body.$error"
            v-model.trim.lazy="$v.body.$model"
            rows="3"
            max-rows="3"
            :disabled="loading"
            )
          ValidateResult(:value="$v.body" :name="$t('ui.body')")
        b-form-group
          label {{ $t('ui.member_list') }}
          i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_promo_member_custom')")
          b-form-textarea.col-12(
            ref="member_list"
            size="sm"
            required
            :dirty="$v.member_list.$dirty"
            :error="$v.member_list.$error"
            v-model.trim.lazy="$v.member_list.$model"
            rows="10"
            max-rows="10"
            trim=true
            :disabled="loading"
            @paste="handlePaste"
          )
          ValidateResult(:value="$v.member_list" :name="$t('ui.member_list')")


    div.mt-4(v-if="isEditAccess")
      SubmitButton.float-right(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" @click="submit")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { required, requiredIf, helpers } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
const validUrl = helpers.regex(
  "validUrl",
  /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(?:[/?#][^\s]*)?$/i
);

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      include_greeting: true,
      body: "",
      title: "",
      member_list: "",
      category: false,
      remark: null
    };
  },
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_promotion");
    },
  },
  validations() {
    return {
      title: {
        required
      },
      body: {
        required
      },
      member_list: {
        required
      },
      remark: {
        required: requiredIf(function () {
          return this.category == true
        }),
        validUrl
      }
    }
  },
  mounted: function() {
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    refresh() {
      this.reset();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.include_greeting = true;
      this.title = "";
      this.body = "";
      this.member_list = "";
      this.category = false;
      this.remark = null;
      this.$v.$reset();
    },
    handlePaste(event) {
      event.preventDefault(); // Prevent the default paste action

      // Get the pasted data from the clipboard
      let pastedData = event.clipboardData.getData('Text');

      // Remove newline characters from the pasted data
      pastedData = pastedData.replace(/\n/g, ' ');

      // Split the pasted data into an array by whitespace characters
      let dataArray = pastedData.split(' ');

      // Remove the first row if it is "ID"
      if (dataArray[0].trim() === 'ID') {
        dataArray.shift();
      }

      // Filter out any empty strings in the array
      dataArray = dataArray.map(item => item.trim()).filter(item => item !== '');

      // Join the array into a comma-separated string
      const commaSeparatedData = dataArray.join(', ');

      // Set the text area content to the comma-separated string
      this.member_list = commaSeparatedData;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const result = this.member_list.split(',').map(item => ({
        account_id: item.trim()
      }));

      this.proceed(result);
    },
    proceed(csv) {
      let url = config.sendMessageUrl()

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        include_greeting: this.include_greeting,
        title: this.title,
        body: this.body,
        member_list: csv,
        category: this.category == true ? "CTA" : null,
        remark: this.category == true ? this.formatUrl(this.remark) : null
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.message"), this.$t("message.success"), "success");
                this.reset();
              } else {
                this.$helpers.showDialog(this.$t("ui.message"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    formatUrl(url) {
      if (!url) return '';

      url = url.trim();

      if (!/^https?:\/\//i.test(url)) {
        url = `https://${url}`;
      }

      return url;
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
</style>